// extracted by mini-css-extract-plugin
export default {"CardContainer":"styles_CardContainer__iV+jd"};